import { Item } from "./Item";

export class UserItem extends Item {
    public updateImage(data: Map<any, any>) {
        return this.getImageTag().src = data.get("src");
    }

    public isConnected(): void {
        this.addClass("connected");
        const tag = this.findById(this.getImageId());
        if (tag) {
            tag.addClass("connected");
        }
    }

    public disconnected(): void {
        this.removeClass("connected");
        const tag = this.findById(this.getImageId());
        if (tag) {
            tag.removeClass("connected");
        }
    }

    protected getImageTag() {
        return this.get("image");
    }

    protected getImageId() {
        return this.get("imageId");
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("image", this.findElementById(this.getImageId()));
    }
}
